export default __webpack_public_path__ + "static/media/BRB.d411b19c.svg";